// @flow
import type { ReduxState } from "../types";

/**
 * Retrieve entrydate for the model catalog
 */
export const getEntryDate = (state: ReduxState): ISO_DATE => {
  return (
    state.modelcatalog?.entryDate ?? new Date().toISOString().split("T")[0]
  );
};
